<template>
  <div class="hero-card text-start">
    <h3 class="fs-32">{{ $t(translationKeyHeadingsmall) }}</h3>
    <h2>{{ $t(translationKeyHeading) }}</h2>
  </div>
</template>

<style lang="scss" scoped>
.hero-card {
  width: 640.35px;

  @media screen and (max-width: 1180px) {
    width: 100% !important;
  }

  padding: 0;

  h2 {
    font-weight: 500;
    font-size: 48px;
    line-height: 58px;
    background-color: transparent !important;
    color: #0000e2;
    margin: 24px 0px 0px 0px;
    padding: 0;

    @media screen and (max-width: 786px) {
      font-size: 32px !important;
      line-height: 38.73px;
    }
  }

  h3 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 0.015em;
    text-transform: uppercase;
    background-color: transparent !important;
    color: #363636;
    padding: 0;

    @media screen and (max-width: 786px) {
      font-size: 18px !important;
    }
  }
}
</style>

<script >
 
export default  {
  props: ["translationKeyHeading", "translationKeyHeadingsmall"],
} 
</script>
